import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'LOGIN_PASSWORD_RESET_TITLE',
    defaultMessage: 'Neues Passwort erstellen',
  },
  subline: {
    id: 'LOGIN_PASSWORD_RESET_SUBLINE',
    defaultMessage:
      'Ein sicheres Passwort enthält mindestens 8 Zeichen, sowohl große wie auch kleine Buchstaben, Zahlen und Sonderzeichen (z. B. *, %, §, ?).',
  },
  labelNew: {
    id: 'LOGIN_PASSWORD_RESET_LABEL_NEW',
    defaultMessage: 'Neues Passwort',
  },
  buttonContinue: {
    id: 'LOGIN_PASSWORD_RESET_BUTTON_CONTINUE',
    defaultMessage: 'Weiter',
  },
  weak: {
    id: 'LOGIN_PASSWORD_STRENGTH_LOW',
    defaultMessage: 'Guter Anfang...',
  },
  average: {
    id: 'LOGIN_PASSWORD_STRENGTH_MIDDLE',
    defaultMessage: 'Fast da',
  },
  strong: {
    id: 'LOGIN_PASSWORD_STRENGTH_HIGH',
    defaultMessage: 'Prima!',
  },
  errorTooShort: {
    id: 'LOGIN_SETTINGS_ERROR_NEW_PASSWORD_TOO_SHORT',
    defaultMessage: 'Bitte geben Sie als Passwort mind. 8 Zeichen ein.',
  },
});
